import { useEffect, useState } from 'react';
import { loadPool } from '../../lib/clawdPool.js';

/* ============================================================
   他这会儿 · 小蟹蟹（2026-11-04 铃点单，放心跳页）
   像素 Clawd 来自「蟹蟹日历」(xiexie-calendar，画：Claude · 审稿：小船，
   CC BY-NC 4.0)，原样放在 public/vendor/clawd-pool.js。
   演的全是真事：/api/studio/now 只认他真实留下的痕迹，
   45 分钟内最新的一件 = 这会儿；什么都没做 = 听心跳。
   ============================================================ */

async function fetchNow() {
  const r = await fetch('/api/studio/now', { credentials: 'include' });
  if (!r.ok) throw new Error('studio/now ' + r.status);
  return r.json();
}

function Crab({ pool, id, label }) {
  const o = pool && pool.POOL.find((x) => x.id === id);
  if (!o) return null;
  return (
    <span
      className="cn-crab"
      role="img"
      aria-label={label}
      dangerouslySetInnerHTML={{ __html: pool.svg(o, { anim: true, label }) }}
    />
  );
}

function ago(at) {
  if (!at) return '';
  const t = new Date(at).getTime();
  if (!t) return '';
  const m = Math.round((Date.now() - t) / 60000);
  if (m < 2) return '刚刚';
  if (m < 60) return `${m} 分钟前`;
  return `${Math.floor(m / 60)} 小时前`;
}

function hhmm(at) {
  const d = new Date(at);
  if (!d.getTime()) return '';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export default function ClawdNow() {
  const [pool, setPool] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    loadPool().then((p) => alive && setPool(p)).catch(() => {});
    const tick = () => fetchNow().then((d) => alive && setData(d)).catch(() => {});
    tick();
    const t = setInterval(tick, 60000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!pool || !data || !data.now) return null;
  const now = data.now;
  const today = data.today || [];

  return (
    <div className="pu-sec-card cn-card">
      <div className="pu-curve-t">他这会儿 · 小蟹蟹替他演</div>
      <div className="cn-now">
        <Crab pool={pool} id={now.crab} label={now.say} />
        <div className="cn-say">
          {now.say}
          {now.at && now.key !== 'chat' && <em>{ago(now.at)}</em>}
        </div>
      </div>

      {today.length > 0 && (
        <>
          <div className="cn-sub">今天他还做了</div>
          <div className="cn-today">
            {today.map((e) => (
              <div className="cn-item" key={e.key + e.at}>
                <Crab pool={pool} id={e.crab} label={e.say} />
                <span className="cn-item-t">{e.say}</span>
                <span className="cn-item-at">{hhmm(e.at)}</span>
              </div>
            ))}
          </div>
        </>
      )}

    </div>
  );
}
